import { Routes, Route, useLocation } from 'react-router-dom'
import ProjectList from './components/ProjectList'
import ProjectView from './components/ProjectView'
import ProjectSpecificationPage from './components/ProjectSpecificationPage'
import UniversalSchemaEditor from './components/shared/UniversalSchemaEditor'
import SchemaEditorRouter from './components/SchemaEditorRouter'
import FlowDemo from './components/FlowDemo'
import EditableEdgesDemo from './components/EditableEdgesDemo-simple'
import DevicesPage from './components/DevicesPage'
import CablesPage from './components/CablesPage'
import CableInstancesPage from './components/CableInstancesPage'
import DeviceInstancesPage from './components/DeviceInstancesPage'
import DeviceInstanceViewPage from './components/DeviceInstanceViewPage'
import TerminalBlocksPage from './components/TerminalBlocksPage'
import TerminalInstancesPage from './components/TerminalInstancesPage'
import CableViewPage from './components/CableViewPage'
import DeviceViewPage from './components/DeviceViewPage'
import Specification from './components/Specification'
import RoomsPage from './components/RoomsPage'
import PrintSheetsPage from './components/PrintSheetsPage'
import PrintSheetEditor from './components/PrintSheetEditor'
import PrintPdfFilesPage from './components/PrintPdfFilesPage'
import KnxSchemaExportPage from './components/KnxSchemaExportPage'
import DeviceTypesPage from './components/DeviceTypesPage'
import CableTypesPage from './components/CableTypesPage'
import CommInterfaceTypesPage from './components/CommInterfaceTypesPage'
import AiProjectPage from './components/AiProjectPage'
import ProjectNetworksPage from './components/ProjectNetworksPage'
import ProjectInterfacesPage from './components/ProjectInterfacesPage'
import ProjectNetworkPrintPage from './components/ProjectNetworkPrintPage'
import ProtectedRoute from './components/auth/ProtectedRoute'
import LoginPage from './components/auth/LoginPage'
import RegisterPage from './components/auth/RegisterPage'
import AdminUsersPage from './components/admin/AdminUsersPage'
import AdminUserAccessPage from './components/admin/AdminUserAccessPageHierarchical'
import UserProfilePage from './components/users/UserProfilePage'
import Header from './components/Header'
import ToastContainer from './components/Toast'

// App component loading

export default function App() {
  // App function called
  
  const location = useLocation()
  const isSchemaEditor =
    location.pathname.includes('/schemas/') &&
    !location.pathname.includes('/specification') &&
    !location.pathname.includes('/knx')
  const isPrintEditor = location.pathname.includes('/prints/') && location.pathname.split('/').length > 4

  return (
    <div className={`min-h-screen bg-gray-100 ${isSchemaEditor || isPrintEditor ? 'h-screen overflow-hidden' : ''}`}>
      <ToastContainer />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route
          path="/flow-demo"
          element={
            <ProtectedRoute>
              <FlowDemo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/editable-edge-demo"
          element={
            <ProtectedRoute>
              <EditableEdgesDemo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId/schemas/terminal"
          element={
            <ProtectedRoute>
              <UniversalSchemaEditor forceSchemaType="terminal" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId/schemas/:schemaId"
          element={
            <ProtectedRoute>
              <SchemaEditorRouter />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId/schemas/:schemaId/specification"
          element={
            <ProtectedRoute>
              <Specification />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId/schemas/:schemaId/knx"
          element={
            <ProtectedRoute>
              <KnxSchemaExportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId/prints/:sheetId"
          element={
            <ProtectedRoute>
              <PrintSheetEditor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId/networks/:networkId/print"
          element={
            <ProtectedRoute>
              <ProjectNetworkPrintPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute>
              <AdminUsersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users/:userId/access"
          element={
            <ProtectedRoute>
              <AdminUserAccessPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users/:userId"
          element={
            <ProtectedRoute>
              <UserProfilePage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={
          <ProtectedRoute>
            <>
              <Header />

              <main className="container mx-auto p-4">
        <Routes>
          <Route path="/" element={<ProjectList />} />
          <Route path="/projects" element={<ProjectList />} />
          <Route path="/device-types" element={<DeviceTypesPage />} />
          <Route path="/cable-types" element={<CableTypesPage />} />
          <Route path="/comm-interface-types" element={<CommInterfaceTypesPage />} />
          <Route path="/projects/:projectId" element={<ProjectView />} />
          <Route path="/projects/:projectId/rooms" element={<RoomsPage />} />
          <Route path="/projects/:projectId/specification" element={<ProjectSpecificationPage />} />
          <Route path="/projects/:projectId/networks" element={<ProjectNetworksPage />} />
          <Route path="/projects/:projectId/networks/:networkId/interfaces" element={<ProjectInterfacesPage />} />
          <Route path="/projects/:projectId/ai" element={<AiProjectPage />} />
          <Route path="/projects/:projectId/prints" element={<PrintSheetsPage />} />
          <Route path="/projects/:projectId/pdf-files" element={<PrintPdfFilesPage />} />
          
          {/* Panel-specific routes */}
          <Route path="/projects/:projectId/panels/:panelId/devices" element={<DevicesPage />} />
          <Route path="/projects/:projectId/panels/:panelId/devices/:deviceId" element={<DeviceViewPage />} />
          <Route path="/projects/:projectId/panels/:panelId/cables" element={<CablesPage />} />
          <Route path="/projects/:projectId/panels/:panelId/cables/:cableId" element={<CableViewPage />} />
          <Route path="/projects/:projectId/panels/:panelId/terminal-blocks" element={<TerminalBlocksPage />} />
          <Route path="/projects/:projectId/panels/:panelId/terminal-blocks/:blockId/instances" element={<TerminalInstancesPage />} />
          <Route path="/projects/:projectId/panels/:panelId/cable-instances" element={<CableInstancesPage />} />
          <Route path="/projects/:projectId/panels/:panelId/device-instances" element={<DeviceInstancesPage />} />
          <Route path="/projects/:projectId/panels/:panelId/device-instances/:instanceId" element={<DeviceInstanceViewPage />} />
          
          {/* Specification-based routes (without panel) */}
          <Route path="/projects/:projectId/cable-instances/spec" element={<CableInstancesPage />} />
          <Route path="/projects/:projectId/device-instances" element={<DeviceInstancesPage />} />
          <Route path="/projects/:projectId/device-instances/:instanceId" element={<DeviceInstanceViewPage />} />
          
          {/* Legacy project-level routes (deprecated) */}
          <Route path="/projects/:projectId/devices" element={<DevicesPage />} />
          <Route path="/projects/:projectId/devices/:deviceId" element={<DeviceViewPage />} />
          <Route path="/projects/:projectId/cables" element={<CablesPage />} />
          <Route path="/projects/:projectId/cables/:cableId" element={<CableViewPage />} />
          <Route path="/projects/:projectId/cable-instances" element={<CableInstancesPage />} />
          <Route path="/projects/:projectId/device-instances" element={<DeviceInstancesPage />} />
        </Routes>
      </main>
            </>
          </ProtectedRoute>
        } />
      </Routes>
    </div>
  )
} 